import styled from 'styled-components'

export const DetailsTable = styled.table`
  width: 100%;
  th, td {
    margin: 4px;
    padding: 4px;
  }
`
